import { render } from "./restaurant.vue?vue&type=template&id=5e01aca8"
import script from "./restaurant.vue?vue&type=script&lang=js"
export * from "./restaurant.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pamenar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__